import React, { useState } from "react";
import {DefaultButton, Dialog, DialogFooter, PrimaryButton} from '@fluentui/react';

const RestorePowerAppBtn = ({powerApp, updateApp}) => {

    const [showDialog, setShowDialog] = useState(false)

    const _onConfirmDialog = () => {
        updateApp(null, null, null, null, true);
        setShowDialog(false)
    }

    const _onCancelDialog = () => {
        setShowDialog(false)
    }

    const confirmationDialog = 
        <Dialog 
            hidden={!showDialog}
            maxWidth={600}
            dialogContentProps={{
                title: `Confirm Restore of "${powerApp.name}" ${powerApp.type}`,
            }}
            modalProps={{
                isBlocking: false
            }}
        >
            <div>
               <p>Are you sure you want to restore this deleted <strong>{powerApp.name}</strong> {powerApp.type}?</p>
            </div>
            <DialogFooter>
                <PrimaryButton onClick={_onConfirmDialog} text="Confirm" />
                <DefaultButton onClick={_onCancelDialog} text="Cancel" />
            </DialogFooter>
        </Dialog>

    return (
        <div style={{float: 'right', marginRight: '-12px'}}>
            <DefaultButton
                text='Restore from Backup'
                className="edit-icon"
                onClick={() => setShowDialog(true)}
            />
            {confirmationDialog}
        </div>
    )
}

export default RestorePowerAppBtn;



// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/RestorePowerAppBtn.js